import React from 'react';
import { Settings, Bell, Shield, Database, Mail } from 'lucide-react';

const Configuracoes = () => {
  return (
    <div className="configuracoes">
      <div className="page-header">
        <h1 className="page-title">Configurações</h1>
        <p className="page-subtitle">Configurações gerais do sistema</p>
      </div>

      <div className="config-grid">
        <div className="config-card">
          <div className="config-header">
            <Bell className="config-icon" />
            <h3>Notificações</h3>
          </div>
          <div className="config-content">
            <label className="config-toggle">
              <input type="checkbox" defaultChecked />
              <span>Email de novos usuários</span>
            </label>
            <label className="config-toggle">
              <input type="checkbox" defaultChecked />
              <span>Relatórios semanais</span>
            </label>
          </div>
        </div>

        <div className="config-card">
          <div className="config-header">
            <Shield className="config-icon" />
            <h3>Segurança</h3>
          </div>
          <div className="config-content">
            <label className="config-toggle">
              <input type="checkbox" defaultChecked />
              <span>Autenticação de dois fatores</span>
            </label>
            <label className="config-toggle">
              <input type="checkbox" />
              <span>Login único (SSO)</span>
            </label>
          </div>
        </div>

        <div className="config-card">
          <div className="config-header">
            <Database className="config-icon" />
            <h3>Backup</h3>
          </div>
          <div className="config-content">
            <p>Último backup: 15/01/2024 às 03:00</p>
            <button className="btn btn-secondary">Executar Backup</button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .config-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 24px;
        }
        .config-card {
          background: white;
          padding: 24px;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .config-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }
        .config-icon {
          width: 24px;
          height: 24px;
          color: #3b82f6;
        }
        .config-header h3 {
          margin: 0;
          color: #1e293b;
        }
        .config-toggle {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
          cursor: pointer;
        }
        .config-content p {
          color: #64748b;
          margin-bottom: 16px;
        }
      `}</style>
    </div>
  );
};

export default Configuracoes;
